<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        title="二维码打印"
         :visible.sync="innerVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <!-- 二维码展示区域  -->
        <div style="overflow-y: scroll;height:400px;" >
      <div v-for="(data,index) in this.PTlist" :key="index" >
      <div  class="content" id="printTest" style="margin-bottom:20px">
      <div style="width: 310px;height: 210px;padding: 10px;border: 3px solid #337E62;margin:30px auto;position: relative;">
        <img src="../../assets/images/YongLv.png" alt="" width="55px" style="float:right;" height="20px" srcset="">
        <div style="color:black;margin-top:5px;width:310px;text-align: left;font-size:6px">
          点位编码：{{data.spotCode}}
        </div>
        <div style="color:black;margin-top:10px;width:310px;text-align: left;font-size:6px">
          点位名称：{{data.spotName}}
        </div>
        <div style="color:black;margin-top:10px;width:310px;text-align: left;font-size:6px">
          项目名称：{{data.projectName}}
        </div>
          <div style="padding: 2px; width: 120px;height: 120px;margin-top:6px;margin-left: 3px;border: 3px dashed #9B9A9B; border-radius: 10px;">
               <div :id="'a'+index" style="display:none">{{data.ramark}}</div>
               <vue-qr :logoSrc="imageUrl" :text="data.ramark" :size="110" :margin="0" colorLight="#ffffff" colorDark="#8bc34a"></vue-qr>
          </div>
          <img src="../../assets/images/figure.png" alt="" style="position: absolute; right:20px;top:80px" width="100px" height="148px"  srcset="">
      </div>
  </div>
  </div> 
  </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" v-print="'#printTest'"  @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
export default {
 components: {vueQr},
  name: "PrintDialog",
  data() {
    return {
        innerVisible: false,
        title:"标题",
        labelPosition:'right',
        PTlist:[],
        imageUrl:require("../../assets/images/logo.png"),
        qrText:"asdsadasdasd",

    };
  },
  methods: {
    modification(){
        this.$emit("dialogV",false)
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    qrcodeimg(){
      for(let val of this.PTlist){
        console.log(val)
        this.qrText == val.ramark
      }
    },

  },
  mounted() {
      this.qrcodeimg()
  }

}
</script>

<style scoped lang="scss">
		.content{
			border: 1px solid #000;
			margin:0 auto;
			page-break-after:always;
      background: #fff;
		}
    .qrcode{
      margin-top: 2px;
      margin-left: 2px;
    }
</style>